import { render, staticRenderFns } from "./image_detail.vue?vue&type=template&id=68dd1c48"
import script from "./image_detail.vue?vue&type=script&lang=js"
export * from "./image_detail.vue?vue&type=script&lang=js"
import style0 from "./image_detail.vue?vue&type=style&index=0&id=68dd1c48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports